import React from 'react';
import { PeekBox } from '../PeekBox.js';

const PeekLoader = ({ height = 50, width = 50, imagePath = "/images/spinner.gif", }) => {
    return (
    //@ts-ignore
    React.createElement(PeekBox, { sx: { height, width }, component: "img", src: imagePath, alt: "Loading..." }));
};

export { PeekLoader, PeekLoader as default };
